// extracted by mini-css-extract-plugin
export default {"container":"style_container__O+Q0v","overflow":"style_overflow__rftX9","directionX":"style_directionX__QAESn","directionY":"style_directionY__rEBPu","mobile":"style_mobile__6qXC2"};